import { createContext, useContext, type ReactNode } from "react";
import type { FirebaseClients } from "./firebase";
import type { RuntimeConfig } from "./runtime-config";

/** Start-up objects (runtime config and Firebase), created once in `main.tsx`. */
export interface Clients {
  config: RuntimeConfig;
  firebase: FirebaseClients;
}

const ClientsContext = createContext<Clients | null>(null);

export function ClientsProvider({ value, children }: { value: Clients; children: ReactNode }) {
  return <ClientsContext.Provider value={value}>{children}</ClientsContext.Provider>;
}

export function useClients(): Clients {
  const clients = useContext(ClientsContext);
  if (clients === null) throw new Error("useClients outside ClientsProvider");
  return clients;
}

/**
 * The api's origin, where email images load from (its image proxy, architecture §6.4); null
 * outside the app shell (component tests), where email frames then load no remote images.
 */
export function useApiOrigin(): string | null {
  const clients = useContext(ClientsContext);
  return clients === null ? null : new URL(clients.config.apiUrl).origin;
}
